import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";
import "./CreatAccount.css";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
// import { s } from "framer-motion/client";
const CreatAccount = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("createAccount.meta.title"),
      description: t("createAccount.meta.description"),
      keywords: t("createAccount.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);
  const GEO_BASE = "https://secure.geonames.org";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    oldpass: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
  });

  const [strength, setStrength] = useState(0);
  const [criteria, setCriteria] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });

  const [suggestions, setSuggestions] = useState({ country: [] });

  /*city-state-country-phone */
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const countryRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const username = "murataktas";
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("90"); // default TR
  /*city-state-country-phone */

  useEffect(() => {
    const run = async () => {
      try {
        const res = await fetch(
          `${GEO_BASE}/countryInfoJSON?username=${username}`
        );
        const data = await res.json();
        setCountryList(Array.isArray(data?.geonames) ? data.geonames : []);
      } catch (e) {
        console.error("Country fetch error:", e);
        setCountryList([]);
      }
    };
    run();
  }, []);

  useEffect(() => {
    const selectedCountry = countryList.find(
      (c) =>
        c.countryName?.toLowerCase() === (formData.country || "").toLowerCase()
    );

    if (!selectedCountry?.countryCode) {
      setCityList([]);
      return;
    }

    const run = async () => {
      try {
        const res = await fetch(
          `${GEO_BASE}/searchJSON?country=${selectedCountry.countryCode}&featureClass=P&maxRows=1000&orderby=population&username=${username}`
        );
        const data = await res.json();
        setCityList(Array.isArray(data?.geonames) ? data.geonames : []);
      } catch (e) {
        console.error("City fetch error:", e);
        setCityList([]);
      }
    };
    run();
  }, [formData.country, countryList]);

  useEffect(() => {
    const selectedCity = cityList.find(
      (c) => c.name?.toLowerCase() === (formData.city || "").toLowerCase()
    );

    if (!selectedCity?.geonameId) {
      setStateList([]);
      return;
    }

    const run = async () => {
      try {
        const res = await fetch(
          `${GEO_BASE}/childrenJSON?geonameId=${selectedCity.geonameId}&username=${username}`
        );
        const data = await res.json();
        setStateList(Array.isArray(data?.geonames) ? data.geonames : []);
      } catch (e) {
        console.error("State fetch error:", e);
        setStateList([]);
      }
    };
    run();
  }, [formData.city, cityList]);

  // Şifreyi kontrol eden fonksiyon
  const isPasswordStrong = (password) => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;
    return strongPasswordRegex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.oldpass) {
      return Swal.fire({
        icon: "error",
        title: t("alerts.oopsTitle"),
        text: t("alerts.passwordMismatch"),
      });
    }

    // Şifre güçlü mü kontrol et
    if (!isPasswordStrong(formData.password)) {
      return Swal.fire({
        icon: "warning",
        title: t("alerts.weakPasswordTitle"),
        text: t("alerts.weakPasswordText"),
      });
    }

    Swal.fire({
      title: t("alerts.createAccountTitle"),
      text: t("alerts.createAccountText"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("alerts.createAccountConfirm"),
      cancelButtonText: t("alerts.cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const dataToSend = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
          address1: formData.address1,
          address2: formData.address2,
          city: formData.city,
          state: formData.state,
          country: formData.country,
        };

        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/users`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToSend),
            }
          );

          if (!response.ok) throw new Error("Server error");

          await response.json();
          Swal.fire(
            t("alerts.successTitle"),
            t("alerts.successText"),
            "success"
          );
          setFormData({
            name: "",
            email: "",
            phone: "",
            password: "",
            oldpass: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            country: "",
          });
          // kriterleri sıfırla
          setCriteria({
            minLength: false,
            uppercase: false,
            lowercase: false,
            number: false,
            specialChar: false,
          });
          // şifre gücünü sıfırla
          setStrength(0);
        } catch (error) {
          Swal.fire(t("alerts.errorTitle"), t("alerts.errorText"), "error");
          console.error(error);
        }
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    if (name === "password") {
      const strengthScore = calculatePasswordStrength(value);
      setStrength(strengthScore);

      // Şifre kurallarını güncelle
      setCriteria({
        minLength: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        specialChar: /[^A-Za-z0-9]/.test(value),
      });
    }

    if (name === "country") {
      if (value.length > 0) {
        const filtered = countryList
          .filter((c) =>
            c.countryName.toLowerCase().includes(value.toLowerCase())
          )
          .map((c) => c.countryName);
        setSuggestions((prev) => ({ ...prev, country: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, country: [] }));
      }
    }

    if (name === "city") {
      if (value.length > 0) {
        const filtered = cityList
          .filter((c) => c.name.toLowerCase().includes(value.toLowerCase()))
          .map((c) => c.name);
        setSuggestions((prev) => ({ ...prev, city: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, city: [] }));
      }
    }

    if (name === "state") {
      if (value.length > 0) {
        const filtered = stateList
          .filter((s) => s.name?.toLowerCase().includes(value.toLowerCase()))
          .map((s) => s.name);
        setSuggestions((prev) => ({ ...prev, state: filtered }));
      } else {
        setSuggestions((prev) => ({ ...prev, state: [] }));
      }
    }
  };

  const calculatePasswordStrength = (password) => {
    let score = 0;

    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    return score;
  };

  const strengthColor = ["danger", "warning", "info", "primary", "success"];

  /*city-state-country*/

  const renderDropdown = (items, onSelect) => {
    return (
      <div
        className="list-group position-absolute w-100"
        style={{ zIndex: 10 }}
      >
        {items.map((item, index) => (
          <button
            type="button"
            key={index}
            className="list-group-item list-group-item-action"
            onClick={() => onSelect(item)}
          >
            {item}
          </button>
        ))}
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !countryRef.current?.contains(event.target) &&
        !cityRef.current?.contains(event.target) &&
        !stateRef.current?.contains(event.target)
      ) {
        setSuggestions({ country: [], city: [], state: [] });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePhoneChange = (value, data) => {
    const dialCode = data.dialCode;

    setPhone(value);
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
    }));

    // Ülke kodunu tamamen koru
    if (!value.startsWith(dialCode)) {
      setPhone(dialCode + value.replace(/\D/g, "").replace(dialCode, ""));
    } else {
      setPhone(value);
    }

    // İlk seferde veya ülke değiştiğinde ülke kodunu güncelle
    if (dialCode && dialCode !== countryCode) {
      setCountryCode(dialCode);
    }

    // Eğer kullanıcı ülke kodunu silmeye çalışıyorsa engelle
    if (!value.startsWith(dialCode)) {
      return;
    }

    setPhone(value);
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 py-5">
            <h2 className="mb-5 createaccounttext">{t("CreateAccount")}</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">{t("NameSurnameLabel")}</label>
                <input
                  type="text"
                  className="form-control p-3"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">{t("EmailLabel")}</label>
                    <input
                      type="email"
                      className="form-control p-3"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">{t("PhoneLabel")}</label>
                    {/* <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    /> */}

                    <PhoneInput
                      country={"tr"}
                      value={phone}
                      onChange={handlePhoneChange}
                      inputProps={{
                        name: "phone",
                        required: true,
                        autoFocus: false,
                      }}
                      inputStyle={{ height: "55px", width: "100%" }} // boyut ayarı
                      required
                    />
                  </div>
                </div>
              </div>

              {/* DENEME */}
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">{t("PasswordLabel")}</label>
                    <input
                      type="password"
                      className="form-control p-3"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    {/* Şifre Güç Barı */}
                    <div className="progress mt-2" style={{ height: "6px" }}>
                      <div
                        className={`progress-bar bg-${
                          strengthColor[strength - 1] || "secondary"
                        }`}
                        role="progressbar"
                        style={{ width: `${(strength / 5) * 100}%` }}
                        aria-valuenow={strength}
                        aria-valuemin="0"
                        aria-valuemax="5"
                      ></div>
                    </div>

                    {/* Şifre kriterleri */}
                    <div className="mb-3 mt-2">
                      <p
                        className={`fs-11 mb-0 ${
                          criteria.minLength ? "text-success" : "text-danger"
                        }`}
                      >
                        {t("PasswordAlert1")}
                      </p>
                      <p
                        className={`fs-11 mb-0 ${
                          criteria.uppercase ? "text-success" : "text-danger"
                        }`}
                      >
                        {t("PasswordAlert2")}
                      </p>
                      <p
                        className={`fs-11 mb-0 ${
                          criteria.lowercase ? "text-success" : "text-danger"
                        }`}
                      >
                        {t("PasswordAlert3")}
                      </p>
                      <p
                        className={`fs-11 mb-0 ${
                          criteria.number ? "text-success" : "text-danger"
                        }`}
                      >
                        {t("PasswordAlert4")}
                      </p>
                      <p
                        className={`fs-11 mb-0 ${
                          criteria.specialChar ? "text-success" : "text-danger"
                        }`}
                      >
                        {t("PasswordAlert5")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">
                      {t("PasswordConfirmLabel")}
                    </label>
                    <input
                      type="password"
                      className="form-control p-3"
                      name="oldpass"
                      value={formData.oldpass}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  {/* Country */}
                  <div className="mb-3 position-relative" ref={countryRef}>
                    <label className="form-label">{t("Country")}</label>
                    <input
                      type="text"
                      name="country"
                      className="form-control p-3"
                      value={formData.country}
                      onChange={handleChange}
                      autoComplete="off"
                      onFocus={() => {
                        const filtered = countryList
                          .filter((c) =>
                            c.countryName
                              .toLowerCase()
                              .includes(formData.country.toLowerCase())
                          )
                          .map((c) => c.countryName);
                        setSuggestions((prev) => ({
                          ...prev,
                          country: filtered,
                        }));
                      }}
                    />
                    {formData.country.length > 0 &&
                      suggestions.country.length > 0 &&
                      renderDropdown(suggestions.country, (item) => {
                        setFormData((prev) => ({
                          ...prev,
                          country: item,
                          city: "",
                          state: "",
                        }));
                        setSuggestions((prev) => ({ ...prev, country: [] }));
                      })}
                  </div>
                </div>
                <div className="col-lg-4">
                  {/* City */}
                  <div className="mb-3 position-relative" ref={cityRef}>
                    <label className="form-label">{t("City")}</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control p-3"
                      value={formData.city}
                      onChange={handleChange}
                      autoComplete="off"
                      onFocus={() => {
                        const filtered = cityList
                          .filter((c) =>
                            c.name
                              .toLowerCase()
                              .includes(formData.city.toLowerCase())
                          )
                          .map((c) => c.name);
                        setSuggestions((prev) => ({ ...prev, city: filtered }));
                      }}
                    />
                    {formData.city.length > 0 &&
                      suggestions.city.length > 0 &&
                      renderDropdown(suggestions.city, (item) => {
                        setFormData((prev) => ({
                          ...prev,
                          city: item,
                          state: "",
                        }));
                        setSuggestions((prev) => ({ ...prev, city: [] }));
                      })}
                  </div>
                </div>
                <div className="col-lg-4">
                  {/* State */}
                  <div className="mb-3 position-relative" ref={stateRef}>
                    <label className="form-label">{t("StateLabel")}</label>
                    <input
                      type="text"
                      name="state"
                      className="form-control p-3"
                      value={formData.state}
                      onChange={handleChange}
                      autoComplete="off"
                      onFocus={() => {
                        const filtered = stateList
                          .filter((s) =>
                            s.name
                              ?.toLowerCase()
                              .includes(formData.state.toLowerCase())
                          )
                          .map((s) => s.name);
                        setSuggestions((prev) => ({
                          ...prev,
                          state: filtered,
                        }));
                      }}
                    />
                    {formData.state.length > 0 &&
                      suggestions.state.length > 0 &&
                      renderDropdown(suggestions.state, (item) => {
                        setFormData((prev) => ({ ...prev, state: item }));
                        setSuggestions((prev) => ({ ...prev, state: [] }));
                      })}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <label className="form-label">{t("AddressLabel")}</label>
                  <input
                    type="text"
                    className="form-control p-3"
                    name="address1"
                    value={formData.address1}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-lg-6">
                  <label className="form-label"> {t("Address2Label")}</label>
                  <input
                    type="text"
                    className="form-control p-3"
                    name="address2"
                    value={formData.address2}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btncreate pe-5 px-5 mt-4 p-3"
              >
                {t("CreateAccount")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatAccount;
